// useUnitFilterTabs.ts
import { useEffect, useState } from "react";
import { useSearchParams } from "next/navigation";
import useUnitsData from "../components/hooks/useUnitInfo";
import { toTitleCase } from "../components/templates/design1/ListingPage1";
import { TabType } from "../components/templates/design2/components/View";

export function useUnitFilterTabs(isDemo: boolean, filterItems: {
    [key: string]: string[];
}) {
    const res = useUnitsData();
    const data = res.unitsData?.unitInfo;
    const parent = !isDemo && data ? data : filterItems;
    const searchparams = useSearchParams();
    const unit_type = searchparams.get("unit_type");
    const unit_sub_type = searchparams.get("unit_sub_type");
    const [current, setCurrent] = useState<TabType>((unit_type as TabType) || "All");
    const [currentSub, setCurrentSub] = useState<string | "All">(unit_sub_type as string || "All");

    useEffect(() => {
        setCurrent((searchparams.get("unit_type") as TabType) || "All");
        setCurrentSub((searchparams.get("unit_sub_type") as string) || "All");
    }, [searchparams]);

    const items = parent![toTitleCase(current)] || [];
    const uniqueItems = Array.from(new Set(items));

    const handleHeaderClick = (tab: TabType) => {
        setCurrent(tab.toLowerCase() as TabType);
        const currentUrl = new URL(window.location.href);
        const searchParams = new URLSearchParams(currentUrl.search);
        if (tab.toLowerCase() !== "all") {
            searchParams.set("unit_type", tab.toLowerCase());
            searchParams.delete("unit_sub_type");
        } else {
            searchParams.delete("unit_type");
            searchParams.delete("unit_sub_type");
        }
        window.history.replaceState(null, "", `${window.location.pathname}?${searchParams.toString()}`);
    };

    const handleSubItemClick = (subItem: string) => {
        setCurrentSub(subItem.toLowerCase());
        const currentUrl = new URL(window.location.href);
        const searchParams = new URLSearchParams(currentUrl.search);
        if (subItem.toLowerCase() !== "all" && subItem.toLowerCase() !== "others") {
            searchParams.set("unit_sub_type", subItem.toLowerCase());
        } else {
            searchParams.delete("unit_sub_type");
        }
        window.history.replaceState(null, "", `${window.location.pathname}?${searchParams.toString()}`);
    };

    return {
        headerItems: !isDemo && data ? ["All", ...Object.keys(data)] : ["All", "Land", "House", "Apartment", "Block of Flat", "Commercial"],
        current,
        currentSub,
        uniqueItems,
        handleHeaderClick,
        handleSubItemClick,
    };
}
